const firebaseConfig = {
    apiKey: "AIzaSyBFJTDkLhLtCyYzNOPwYh2-zunHn2J2sDo",
    authDomain: "traveezy-make-travel-easy.firebaseapp.com",
    projectId: "traveezy-make-travel-easy",
    storageBucket: "traveezy-make-travel-easy.appspot.com",
    messagingSenderId: "845255394933",
    appId: "1:845255394933:web:0ec46ffc6786c6dc219a3c"



    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID
};
export default firebaseConfig